import { FC } from 'react';
import {
    SkeletonWrapper,
    SkeletonCell,
    SkeletonTopCell,
    SkeletonMiddleCell
} from './Skeleton.styled';

type SkeletonProps = {
    rows?: number;
    header?: boolean;
};

const Skeleton: FC<SkeletonProps> = ({ rows = 8, header = true }) => (
    <SkeletonWrapper>
        {header && (
            <>
                {/* Верхняя плашка (3vh, 40%, по центру) */}
                <SkeletonTopCell />

                {/* Средняя плашка (4vh, 100%) */}
                <SkeletonMiddleCell />
            </>
        )}

        {/* Основные плашки */}
        {Array(rows)
            .fill(0)
            .map((_, index) => (
                <SkeletonCell key={index} />
            ))}
    </SkeletonWrapper>
);

export default Skeleton;
